















































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Action, Mutation, State } from 'vuex-class';
import { ICurrentPage } from '~/store/types';
import BraveLauncherWarningBanner from '~/components/Games/BraveLauncherWarningBanner.vue';
import BuyNodePromotion from '~/components/Promotions/BuyNodePromotion.vue';
import GameActionButton from '~/components/Games/GameActionButton.vue';
import GameMobilePlaytestButton from '~/components/Games/GameMobilePlaytestButton.vue';
import GameRequiredItemButton from '~/components/Games/GameRequiredItemButton.vue';
import { gamesIntlHead } from '~/utils/i18n_head';
import { IUser } from '~/store/profile/types';
import { CheckForRequiredItems, GameActionButtonHost } from '~/mixins';

@Component({
  head: gamesIntlHead(),
  components: {
    BraveLauncherWarningBanner,
    BuyNodePromotion,
    GameActionButton,
    GameRequiredItemButton,
    GameMobilePlaytestButton,
  },
})
export default class Games extends Mixins(
  CheckForRequiredItems,
  GameActionButtonHost,
) {
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  @Action('gameActiveUsers', { namespace: 'games' })
  private gameActiveUsers!: (data: {
    gameName: string;
    inDataBricks?: boolean;
  }) => Promise<void>;

  @Action('getUserItems', { namespace: 'inventory' })
  private getUserItems!: () => Promise<string>;

  isBrave: boolean = (navigator as any).brave !== undefined;
  iosReg = /i(Phone|Pad|Pod)/gi;
  androidReg = /Android/gi;
  userIsIOS: boolean = this.iosReg.test((navigator as any).userAgent);
  userIsAndroid: boolean = this.androidReg.test((navigator as any).userAgent);
  userIsMobile: boolean = this.userIsIOS || this.userIsAndroid;

  activeUsers: {
    [key: string]: number;
  } = {};

  created() {
    this.gameActionButtonHostCreated();

    this.games.map(game => {
      if (game.showActivePlayers === true) {
        this.gameActiveUsers({
          gameName: game.codeName,
          inDataBricks: game.activePlayerCountInDataBricks,
        });
      } else {
        game.activeUsers = 0;
      }
    });

    this.getUserItems();
  }

  destroyed() {
    this.gameActionButtonHostDestroyed();
  }

  get formattedGames() {
    return this.games
      .filter(
        ({ showGamePage, isTotallyBlocked }) =>
          showGamePage && !isTotallyBlocked,
      )
      .map(game => {
        const gameInstallStatus = this.gamesInstallStatuses[game.codeName];
        const requiredItemStatus = this.getRequiredGameItemStatus(game);
        if (gameInstallStatus) {
          return {
            ...game,
            isInstalled: gameInstallStatus.isInstalled,
            installedVersion: gameInstallStatus.version,
            requiredItemStatus: requiredItemStatus,
          };
        } else {
          return {
            ...game,
            requiredItemStatus: requiredItemStatus,
          };
        }
      });
  }

  goToStore(gameRoute: string) {
    this.$router.push(`/games/${gameRoute}`);
  }

  apkDownloadClick(gameName: string) {
    // UA tracking
    this.$ua.trackApkDownloadEvent({
      game: gameName,
    });
  }

  iosDownloadClick(gameName: string) {
    // UA tracking
    this.$ua.trackIosDownloadEvent({
      game: gameName,
    });
  }
}
